export default "__VITE_ASSET__ad021449__"